<template>
    <button 
      @click="handleClick" 
      class="flex items-center py-3 -mt-[10px] hover:opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
      type="button"
      aria-label="Go to previous step"
    >
      <Icon
        icon="chevron-left"
        :icon-color="'hsl(var(--twc-dark-1))'"
        stroke="none"
        width="20"
        height="20"
      />
      <span class="pl-1 underline text-dark-1 text-body4 hover:[@media(hover:hover)]:no-underline">{{ text }}</span>
    </button>
  </template>
  
<script setup lang="ts">
import { useRouter } from 'vue-router';
import { ref, watch } from 'vue';
import { useProgressStore } from '@/stores/modules/progressStore';

const { text, backRoute } = defineProps<{
  text: string;
  backRoute?: string;
}>();

const router = useRouter();
const progressStore = useProgressStore();

const canGoBack = ref(false);

watch(
  [() => window.history.state?.back, () => window.history.length, () => progressStore.previousPage, () => progressStore.pageName],
  () => {
    canGoBack.value = (window.history.state?.back || window.history.length > 1) && 
                      progressStore.previousPage !== progressStore.pageName;
  },
  { immediate: true }
);

const handleClick = () => {
  if (backRoute && backRoute != '') {
    router.push({ name: backRoute });
    return;
  }
  router.go(-1);
};
</script>